import { decodeText } from "../../decode-text";
export const containsHtml = (input) => {
    const htmlTags = /<[^>]*>/g; // Regular expression for matching any HTML tag
    return htmlTags.test(decodeText(input));
};
